export default {
  title: "Profilim",
  saved: "Profil saqlandi",
  account: {
    title: "Akkaunt",
    fullName: "To'liq ism",
    username: "Login",
    role: "Rol",
    branch: "Filial",
    manager: "Menejer",
    memberSince: "Qo'shilgan sana",
    managed: "Menejeringiz boshqaradi. O'zgartirish uchun unga murojaat qiling.",
  },
  timezone: {
    title: "Vaqt zonasi",
    myTime: "Mening vaqtim",
    branchHint: "Filial vaqt zonasi: {{tz}}",
    driverTimes: "Driver vaqtlari driver shtati vaqti + sizning vaqtingizda ko'rsatiladi.",
  },
  notifications: {
    title: "Bildirishnomalar",
    inApp: "Ilova ichida bildirishnomalar",
    telegram: "Telegram",
    telegramHint: "Keyingi bosqichda",
  },
  password: {
    title: "Parolni o'zgartirish",
    current: "Joriy parol",
    new: "Yangi parol",
    confirm: "Yangi parolni tasdiqlang",
    mismatch: "Parollar mos kelmaydi",
    hint: "Kamida 10 ta belgi. Eski parol bilan bir xil bo'lmasin.",
    update: "Parolni yangilash",
    updated: "Parol yangilandi",
    failed: "Parolni o'zgartirib bo'lmadi",
  },
  twofa: {
    title: "Ikki bosqichli tekshiruv",
    requiredRole: "Rolingiz uchun majburiy",
    disable: "O'chirish",
    enable: "2FA'ni yoqish",
    ownerAdvice: "Ega akkaunti uchun 2FA tavsiya etiladi: u butun kompaniyani himoya qiladi.",
    intro: "Akkauntingizni authenticator ilovasidagi 6 xonali kod bilan himoyalang (Google Authenticator, Authy, 1Password).",
    step1: "1. Bu QR kodni authenticator ilovasi bilan skanerlang.",
    manual: "Skanerlab bo'lmayaptimi? Kalitni qo'lda kiriting:",
    step2: "2. Ilovadagi 6 xonali kodni kiriting.",
    backupHint: "Yoqilgandan keyin 10 ta zaxira kod olasiz. Ular faqat bir marta ko'rsatiladi.",
    backupTitle: "Zaxira kodlar — hozir saqlab oling, ular faqat bir marta ko'rsatiladi.",
    savedThem: "Saqlab oldim",
    enabledText: "Yoqilgan. Har kirishda kod so'raladi.",
    newPhone: "Telefon almashdimi? 2FA'ni o'chirib, qayta sozlang.",
    newPhoneAskOwner: "Telefon almashdimi? Egasidan 2FA'ni tiklashni so'rang (Admin → Users), keyin qayta sozlang.",
    newPhoneOwner: "Telefon almashdimi? Settings → Security'da “Egasi” belgisini olib, 2FA'ni o'chiring va qayta sozlang.",
    enabledToast: "Ikki bosqichli tekshiruv yoqildi",
    disabledToast: "Ikki bosqichli tekshiruv o'chirildi",
    enableFailed: "2FA'ni yoqib bo'lmadi",
    disableFailed: "2FA'ni o'chirib bo'lmadi",
    disableTitle: "Ikki bosqichli tekshiruvni o'chirish",
    disableDesc: "Parolingiz bilan tasdiqlang.",
    password: "Parol",
    qrAlt: "QR kod",
  },
};
